// Functions to filter product recommendations by checking calulation results.
import allProducts from '../../components/custom/data/productData.json'
export interface Product {
    label: {[key: string]: string | undefined;},
    heading: {[key: string]: string;},
    body: {[key: string]: string;},
    imageUrl: string,
    productLink: string,
    weight: number,
    rhmin: number,
    rhmax: number,
    tmin: number,
    tmax: number,
    pmin: number,
    pmax: number
}

function shuffleArray(array: Product[]) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  export function pickTwoRandom(array: Product[]) {
    const shuffledArray = shuffleArray([...array]);
    return shuffledArray.slice(0, 2);
  }

  function filterProducts (products: Product[], rh: number, t: number, p:number): Product[] {
    const filtered: Product[] = products?.filter((product: Product) => product.rhmin <= rh && product.rhmax >= rh)
                              .filter((product: Product) => product.tmin <= t && product.tmax >= t)
                              .filter((product: Product) => product.pmin <= p && product.pmax >= p);

    filtered.sort((a, b) => a.imageUrl.localeCompare(b.imageUrl));

    return filtered;
  }

  function arraysAreEqual(arr1: Product[], arr2: Product[]) {
    return arr1.length === arr2.length && arr1.every((obj, index) => JSON.stringify(obj) === JSON.stringify(arr2[index]));
  }

export const recommendProducts = (rh: number, t: number, p:number, previous: Product[]): {'products': Product[], 'previous': boolean} => {

    if (rh > 100) {
      return {
        'products': previous,
        'previous': true
      }
    }

    const allRecommended: Product[] = allProducts.products;

    const newRecommended = filterProducts(allRecommended, rh, t, p)

    if (arraysAreEqual(newRecommended, previous)) {
      return {
        'products': previous,
        'previous': true
      }
    }

    // Siirrä mahdollisesti random pois täältä, jotta koko previous saadaan mukaan
    const randomRecommendations = pickTwoRandom(allRecommended)

    return {
      'products': newRecommended,
      'previous': false
    }
}